import Vue from 'vue'
import App from './App.vue'
import en from './commons/lang/en'
import zh from './commons/lang/zh'
import VueI18n from 'vue-i18n'


Vue.config.productionTip = false
Vue.use(VueI18n)

function getLanguage() {
  if (localStorage.getItem('lang') != undefined) {
    if (localStorage.getItem('lang') == 'zh') {
      localStorage.setItem('lang', 'zh');
      return new VueI18n({
        locale: 'zh',
        messages: {
          zh
        }
      })
    }else{
      localStorage.setItem('lang', 'en');
      return new VueI18n({
        locale: 'en',
        messages: {
          en
        }
      })
    }
  } else {
    if (navigator.language.substr(0, 2) == 'zh' || (navigator.language.substr(0, 2) != undefined && navigator.language.substr(0, 2).substr(0, 2) == 'zh')) {
      localStorage.setItem('lang', 'zh');
      return new VueI18n({
        locale: 'zh',
        messages: {
          zh
        }
      })
    } else {
      localStorage.setItem('lang', 'en');
      return new VueI18n({
        locale: 'en',
        messages: {
          en
        }
      })
    }
  }

}

const i18n = getLanguage();



new Vue({
  el: '#app',
  // router,
  i18n, // 挂在到Vue实例上
  render: h => h(App)
})
